//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: 'KickboxingWorks',
  data() {
    return {
      reasons: [
        {
          id: 1,
          title: 'High Intensity',
          description: 'High-intensity interval training (HIIT) is proven to provide an extremely effective and efficient workout. Our trainers will push you to give it your all throughout the workout.',
        },
        {
          id: 2,
          title: '3 Minutes On, 1 Minute Off',
          description: 'Our formula relies on short, intense bursts and rests to keep the body guessing and the heart pumping. Three-minute rounds followed by one-minute recovery periods model the cadence of a real fight.',
        },
        {
          id: 3,
          title: 'Balanced Training',
          description: 'Improve endurance, flexibility, speed and power all in one dynamic workout. We cue up a powerful combo of kickboxing and bodyweight exercises to give you the best of cardio and strength training.',
        },
      ],
    };
  },
};
